import { styled, alpha } from '@mui/material/styles';
import { Drawer, List, Toolbar } from '@mui/material';

const drawerWidth = 200;
const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 92;

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    boxSizing: 'border-box',
    background: theme.palette.background.default,
    color: theme.palette.primary.contrastText,
  },
}));

export const StyledList = styled(List)(({ theme }) => ({
  '& .MuiListItem-root': {
    color: theme.palette.primary.contrastText,
    '&.Mui-selected': {
      background: alpha(theme.palette.primary.contrastText, 0.1),
      '&:hover': {
        background: alpha(theme.palette.primary.contrastText, 0.2),
      },
    },
  },
  '& .MuiListItemIcon-root': {
    color: theme.palette.primary.contrastText,
  },
}));

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  display: "flex",
  alignSelf: "center",
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));
